import React from 'react';

import { BenefitType, getBenefitIcon } from '@epi-constants/benefitTypes';
import { IBeneficiary } from '@epi-models/pages/Beneficiaries';
import { EditIcon, Box, Button, ButtonMode, ButtonSize } from 'edenred-ui';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { IBenefitGroup } from '@epi-models/pages/BenefitGroups';

import {
  ActionButton,
  BenefitIcons,
  ButtonContent
} from './BeneficiariesTable.styled';

type OwnProps = {
  beneficiary: IBeneficiary;
  showDetail: (personId: string) => void;
  groupSetting?: IBenefitGroup;
  endOfFundsDatePassed: boolean;
};

export const BeneficiaryActions = ({
  beneficiary,
  showDetail,
  groupSetting,
  endOfFundsDatePassed
}: OwnProps) => {
  const { t } = useTranslation();
  const { primaryFrontColor, altGray1 } = useTheme();
  const editBeneficiary = (e: React.MouseEvent) => {
    e.stopPropagation();
    showDetail(beneficiary.personId);
  };

  const isBenefitACtiveForUser = (type: string): boolean => {
    if (!groupSetting?.benefitSettings) return false;
    return groupSetting?.benefitSettings.some(
      s => s.benefitType.toLowerCase() === type.toLowerCase()
    );
  };
  const getBenefitIconByState = (type: string) => {
    const color =
      !endOfFundsDatePassed && isBenefitACtiveForUser(type)
        ? primaryFrontColor
        : altGray1;

    return getBenefitIcon(t, type, color);
  };

  return (
    <Box
      position="relative"
      display="flex"
      justifyContent="flex-end"
      alignItems="center"
    >
      <BenefitIcons display="flex">
        {Object.values(BenefitType)
          .sort(
            (a, b) =>
              Number(isBenefitACtiveForUser(b)) -
              Number(isBenefitACtiveForUser(a))
          )
          .map(benefitType => (
            <Box display="inline" key={benefitType} mr={1}>
              {getBenefitIconByState(benefitType)}
            </Box>
          ))}
      </BenefitIcons>
      {!endOfFundsDatePassed && (
        <ActionButton position="absolute" right={0}>
          <Button
            id={`edit-employee-btn-${beneficiary.personId}`}
            mode={ButtonMode.Secondary}
            size={ButtonSize.Small}
            onClick={editBeneficiary}
          >
            <ButtonContent>
              <EditIcon />
              {t('containers.beneficiaries.detail.edit_title')}
            </ButtonContent>
          </Button>
        </ActionButton>
      )}
    </Box>
  );
};
